import ElementUI from 'element-ui'
import axios from 'axios'
import store from '../store'
import deviceInfo from '@/utils/deviceInfo';
import { withAwait } from '@/utils/hoc'
import { GetAuthUrl } from '@/views/vat_centre/declare/getAuthUrl'
var baseURL = process.env.NODE_ENV === 'development'? 
  '/api' : 
  'https://tax.cmkmtd.com/api/ucentercn';
const timeout = 30000;
const downloadTimeout = 300000;
const request = axios.create({
  baseURL,
  timeout,
})
request.interceptors.request.use(
  async config => {
    //解决IE请求相同地址，直接调用缓存的问题
    config.headers['cache-control'] = 'no-cache';
    config.headers['pragma'] = 'no-cache';
    config.headers['lang'] = 'zh-cn';
    if (store.getters.token) 
      config.headers['Authorization'] = `Bearer ${store.getters.token}`;
    //判断是否需要在头部加上device信息
    let param = config.data || config.params || {};
    let { NEED_DEVICE } = param;
    if(NEED_DEVICE) config.headers['device'] = 
    JSON.stringify(new deviceInfo().getConfig());
    return config;
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)
let logoutTimer = null;
request.interceptors.response.use(
  response => {
    const res = response.data;
    let {code, message} = res;
    if (res.code != 200) {
      if(res.code == 401){
        if(logoutTimer) return;
        logoutTimer = setTimeout(() => logoutTimer = null, 1000);
        ElementUI.Message({
          message: '您的账号已登出或登录超时，即将登出...',
          type: 'warning',
          duration: 2000,
          onClose: () => {
            store.dispatch('LogOut');
            location.reload();
          }
        })
      }else if(res.code === 4444){
        GetAuthUrl(message);
      }else{
        let HIDE_WARN = response.config.params && 
        response.config.params.HIDE_WARN ||
        response.config.data &&
        JSON.parse(response.config.data).HIDE_WARN
        ? true 
        : false;
        if(!HIDE_WARN){
          ElementUI.Message({
            message: res.message,
            type: 'warning',
          })
        }
      }
      return Promise.reject({code, msg: message, type: 'warn'});
    } 
    return Promise.resolve(res.data);
  },
  error => {
    let res = error.response;
    let msg = res && res.data && res.data.message 
    ? res.data.message
    : error.message;
    ElementUI.Message({
      message: msg,
      type: 'error',
    })
    return Promise.reject({code: res.status, msg, type: 'error'})
  }
)

const download = axios.create({
  baseURL,
  timeout: downloadTimeout,
  withCredentials: true,
  responseType: 'blob'
})
download.interceptors.request.use(
  config => {
    if (store.getters.token) {
      //解决IE请求相同地址，直接调用缓存的问题
      config.headers['cache-control'] = 'no-cache';
      config.headers['pragma'] = 'no-cache';
      config.headers['lang'] = 'zh-cn';
      if (store.getters.token) 
        config.headers['Authorization'] = `Bearer ${store.getters.token}`;
    }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)
download.interceptors.response.use(
  async res => {
    if(res.headers['content-type'] === 'application/octet-stream'){
      let filename = null;
      let disposition = res.headers['content-disposition'];
      filename = disposition.split(';')
      .find(item => item.indexOf('filename=') != -1)
      .split('filename=')[1]
      let resObj = {
        filename: filename || new Date().getTime()+'',
        data: res.data
      }
      return resObj;
    }else{
      let [ data, err ] = await withAwait(res.data.text());
      if(data){
        data = JSON.parse(data);
        ElementUI.Message({
          message: '下载失败：'+data.message,
          type: 'error'
        })
        return Promise.reject(data.message);
      }else if(err){
        ElementUI.Message({
          message: '下载失败：'+err,
          type: 'error'
        })
        return Promise.reject('下载失败：'+err);
      }
    }
  },
  error => {
    ElementUI.Message({
      message: '下载失败：'+error,
      type: 'error'
    })
    return Promise.reject(error)
  }
)

export {
  request,
  download
}



// WEBPACK FOOTER //
// ./src/api/request.js